<template>
  <v-container>
    <v-alert
      :type="alertType"
      transition="scale-transition"
      v-model="alertShow"
      border="left"
      dismissible
    >{{alertMsg}}</v-alert>
    <v-card>
      <v-list>
        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('Admin.User.infos')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mb-3" v-text="'ID : '+user.id"></v-list-item-title>

              <v-list-item-subtitle v-html="'Username : '+user.username"></v-list-item-subtitle>
              <v-list-item-subtitle v-html="'Mail : '+user.mail"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('Admin.User.update')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <v-container>
                <v-row align="center">
                  <v-col cols="12" sm="7">
                    <div class="text-subtitle-2 mb-2" v-text="$t('Admin.User.username')"></div>
                    <template>
                      <v-text-field solo v-model="newUsername">
                        <v-btn
                          slot="append"
                          color="primary"
                          @click="save('username')"
                        >{{$t('Admin.User.edit')}}</v-btn>
                      </v-text-field>
                    </template>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="7">
                    <div class="text-subtitle-2 mb-2" v-text="$t('Admin.User.mail')"></div>
                    <template>
                      <v-text-field :rules="[rules.validateEmail]" solo v-model="newMail">
                        <v-btn
                          slot="append"
                          color="primary"
                          @click="save('mail')"
                        >{{$t('Admin.User.edit')}}</v-btn>
                      </v-text-field>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('Admin.User.password')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <v-container class="pr-12">
                <v-form v-model="changePassOk">
                  <v-row align="center">
                    <v-col cols="12" sm="6">
                      <div class="text-subtitle-2 mb-2" v-text="$t('Admin.User.newPassword')"></div>
                      <template>
                        <v-text-field
                          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
                          solo
                          v-model="newPassword"
                        ></v-text-field>
                      </template>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="text-subtitle-2 mb-2" v-text="$t('Admin.User.verifNewPassword')"></div>
                      <template>
                        <v-text-field
                          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
                          solo
                          v-model="verifNewPassword"
                        ></v-text-field>
                      </template>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row align="center">
                  <v-col class="text-center">
                    <v-btn color="primary" @click="savePassword">{{$t('Admin.User.save')}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('Admin.User.permissions')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <v-row align="center">
                <v-col cols="12" sm="3">
                  <v-checkbox
                    :disabled="disable"
                    class="ml-5"
                    v-model="admin"
                    :label="`global admin`"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-btn
                    :disabled="disable"
                    color="primary"
                    @click="saveAdmin"
                  >{{$t('Admin.User.save')}}</v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
    <v-row>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DataHome.back')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {},
  data() {
    return {
      newUsername: "",
      newMail: "",
      user: null,
      rules: {
        validateEmail: (value) => {
          var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
          return (
            re.test(String(value).toLowerCase()) ||
            this.$t("Login.RegisterComponent.rules.mail")
          );
        },
        required: (value) =>
          !!value || this.$t("Login.RegisterComponent.rules.required"),
        min: (v) =>
          v.length >= 8 || this.$t("Login.RegisterComponent.rules.min"),
        max: (v) =>
          v.length <= 20 || this.$t("Login.RegisterComponent.rules.max"),
        uppercase: (value) =>
          /^(?=.*[A-Z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.uppercase"),
        lowercase: (value) =>
          /^(?=.*[a-z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.lowercase"),
        digit: (value) =>
          /^(?=.*[0-9])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.digit"),
        nospace: (value) =>
          /^\S+$/.test(value) ||
          this.$t("Login.RegisterComponent.rules.nospace"),
      },
      alertType: "success",
      alertShow: false,
      alertMsg: "",
      admin: false,
      disable: false,
      newPassword: "",
      verifNewPassword: "",
      changePassOk: false,
    };
  },
  props: {
    choosenUser: Object,
    path: String,
  },
  computed: {
    passOk(){
      return (this.newPassword == this.verifNewPassword) && this.changePassOk
    }
  },
  watch: {
    data: function () {
      this.loading = false;
      this.disable = false;
    },
  },
  methods: {
    save: function (value) {
      let json = {};
      switch (value) {
        case "username":
          json.username = this.newUsername;
          break;
        case "mail":
          json.mail = this.newMail;
          break;
      }
      axios
        .put(process.env.VUE_APP_API_ADDR + "/api/user/" + this.user.id, json, {
          headers: { Authorization: tokenStore.getToken() },
        })
        .then((res) => {
          if (res.data.success) {
            tokenStore.refreshToken();
            this.reload();
            window.scrollTo(0, 0);
            this.alertType = "success";
            this.alertShow = true;
            this.alertMsg = this.$t("Admin.User.saved");
          }
        })
        .catch((err) => {
          this.alertType = "error";
          this.alertShow = true;
          this.alertMsg = err.response.data.errorMessage;
        });
    },
    savePassword: function () {
      if (this.passOk) {
        let json = {
          newPassword: this.newPassword,
          verifNewPassword: this.verifNewPassword
        };
        axios
          .put(
            process.env.VUE_APP_API_ADDR + "/api/user/" + this.user.id +"/password",
            json,
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then((res) => {
            if (res.data.success) {
              tokenStore.refreshToken();
              this.reload();
              window.scrollTo(0, 0);
              this.alertType = "success";
              this.alertShow = true;
              this.alertMsg = this.$t("Admin.User.saved");
            }
          })
          .catch((err) => {
            this.alertType = "error";
            this.alertShow = true;
            this.alertMsg = err.response.data.errorMessage;
          });
      } else {
        this.alertType = "error";
        this.alertShow = true;
        this.alertMsg = "Complete correctly the password form";
      }
    },
    saveAdmin: function () {
      axios
        .put(
          process.env.VUE_APP_API_ADDR + "/api/user/" + this.user.id + "/admin",
          { admin: this.admin },
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          if (res.data.success) {
            tokenStore.refreshToken();
            this.reload();
            window.scrollTo(0, 0);
            this.alertType = "success";
            this.alertShow = true;
            this.alertMsg = this.$t("Admin.User.saved");
          }
        })
        .catch((err) => {
          this.alertType = "error";
          this.alertShow = true;
          this.alertMsg = err.response.data.errorMessage;
        });
    },
    reload: function () {
      axios
        .get(process.env.VUE_APP_API_ADDR + "/api/user/" + this.user.id, {
          headers: { Authorization: tokenStore.getToken() },
        })
        .then((res) => {
          if (res.data.success) {
            this.user = res.data.user;
          }
        })
        .catch((err) => {
          this.alertType = "error";
          this.alertShow = true;
          this.alertMsg = err.response.data.errorMessage;
        });
    },
  },
  beforeMount: function () {
    this.newUsername = this.choosenUser.username;
    this.newMail = this.choosenUser.mail;
    this.user = this.choosenUser;
    this.admin = this.choosenUser.permissions.admin;
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() },
      })
      .then((res) => {
        if (res.data.success) {
          this.ownId = res.data.user.id;
          if (this.user.id == this.ownId) {
            this.disable = true;
          }
        }
      })
      .catch((err) => {
        this.alertType = "error";
        this.alertShow = true;
        this.alertMsg = err.response.data.errorMessage;
      });
  },
  mounted: function () {},
  beforeDestroy: function () {},
};
</script>
